import $ from 'jquery';
import TeaserFadeView from './TeaserFadeView';
import { randRange } from '../../home24-shared/core/Utils';

export default TeaserFadeView.extend({
  disableRandomSeed: false,

  /**
   * @type {$}
   */
  $bullets: null,

  /**
   * Return array index based on weights
   *
   * @param {Array} weight
   * @return {Number}
   */
  getRandomWithWeight: function(weight) {
    var totalWeight = weight.reduce(function(prev, cur) {
      return prev + cur;
    });

    var randomNum = randRange(0, totalWeight);
    var weightSum = 0;

    for (var i = 0; i < weight.length; i++) {
      weightSum += weight[i];
      weightSum = +weightSum.toFixed(2);

      if (randomNum <= weightSum) {
        return i;
      }
    }

    // TODO: before it returned undefined
    return 0;
  },

  /**
   * This method selects first teaser with weighted probability from all available teasers
   * @returns {Number}
   */
  seedTeaser: function() {
    if (this.disableRandomSeed) {
      this.activeTeaser = 0;
    } else {
      var iLength = this.$teasers.length;
      var i;
      var iLastWeight = 1;
      var aWeights = [];

      /*
       * Generate weights array
       */
      for (i = 0; i < iLength; i++) {
        aWeights[i] = iLastWeight;

        iLastWeight -= 0.1;
        if (iLastWeight < 0.1) {
          iLastWeight = 0.1;
        }
      }

      this.activeTeaser = this.getRandomWithWeight(aWeights);
    }
  },

  toGlobalFallback: function() {
    this.$('.ui-slider-to-left').remove();
    this.$('.ui-slider-to-right').remove();
    this.$('.bullet-teaser__bullet-container').remove();
  },

  /**
   * Rescale teaser to desired dimensions
   * @param {Number} width
   * @param {Number} height
   */
  rescale: function(width, height) {
    var iWidth = parseInt(width, 10) > 0 ? parseInt(width, 10) : 0;
    var iHeight = parseInt(height, 10) > 0 ? parseInt(height, 10) : 0;

    if (iWidth > 0) {
      this.$el.width(iWidth);
      this.$('.iframe, .teaser-element').width(iWidth);
    }

    if (iHeight > 0) {
      this.$el.height(iHeight);
      this.$('.iframe, .teaser-element').height(iHeight);
    }
  },

  /**
   * Method renders nav bullets based on included teasers
   */
  addBullets: function() {
    var iLength = this.$teasers.length;
    var $bulletContainer;
    var i;
    var sHtml = '';

    this.$el.append("<div class='bullet-teaser__bullet-container'></div>");
    $bulletContainer = this.$('.bullet-teaser__bullet-container');

    for (i = 0; i < iLength; i++) {
      sHtml +=
        '<span class="bullet-teaser__bullet" data-index="' + i + '"></span>';
    }

    $bulletContainer.append(sHtml);

    this.$bullets = this.$('.bullet-teaser__bullet');
    this.$bullets.on('click', $.proxy(this.onBulletClick, this));
  },

  onBulletClick: function(event) {
    var $cT = $(event.currentTarget);
    var iIndex = $cT.data('index');

    if (typeof iIndex === 'number') {
      this.fadeTo(iIndex);
      this.restartTimer();
    }
  },

  syncBullets: function() {
    this.$bullets.removeClass('bullet-teaser__bullet--active');
    this.$bullets
      .eq(this.activeTeaser)
      .addClass('bullet-teaser__bullet--active');
  },

  /**
   * Teaser preinit hook used in implement per slider adjustments
   */
  preInit: function() {
    if (this.$el.data('disable-random-seed')) {
      this.disableRandomSeed = true;
    }

    this.rescale(this.$el.data('width'), this.$el.data('height'));
  },

  postInit: function() {
    if (!this.$el.data('disable-bullets')) {
      this.addBullets();
      this.syncBullets();
    }
  },

  postFadeTo: function() {
    this.syncBullets();
  }
});



/** WEBPACK FOOTER **
 ** ./legacy/home24-desktop/layout/TeaserBulletView.js
 **/